<header></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <!-- <app-left-panel-prelogin activeTab="4"></app-left-panel-prelogin> -->
        <left-panel activeTab="4" *ngIf="this.auth?.detailuser != undefined"></left-panel>
        <app-left-panel-prelogin activeTab="4" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
    </div> 
    <div class="post-login-1-col-2">
        <div class="discover-box bg-8f8">
            <div class="link" (click)="back()">
                <ng-icon iconClass="icon-arrow-left-black" width="22" height="22"></ng-icon>
            </div>
            <grid-row class="mt-20 justify-content-between align-item-center">
                <grid-col col="4">
                    <div class="font-600 font-size-32px line-h-40 letter-spacing-03">
                        {{"Offers" | translate }}
                    </div>
                </grid-col>
                <grid-col col="auto">
                    <div class="position-relative">
                        <ng-icon iconClass="icon-like-32px link" width="32" height="32" (click)="LandingPageMyFavourites()" *ngIf="this.auth?.detailuser"></ng-icon>
                        <span class="position-relative" *ngIf="this.auth?.detailuser">
                            <ng-icon iconClass="icon-filter-big ml-20 link" width="32" height="32" (click)="FilterIcon()"></ng-icon>
                            <span class="icon-filter-transaction-active" *ngIf="this.CardName != undefined && this.CardName != ''"></span>
                        </span>
                        <div class="drop-menu" [ngClass]="this.addClassActive ? 'active':''">
                            <div class="drop-menu-box">
                                <div class="drop-menu-box-item" (click)="GetOfferPaginatedbyCard('AllCard',-1,'')">
                                    {{ "AllCards" | translate }}
                                </div>
                                <div class="drop-menu-box-item"  *ngFor="let C of this.Filterdata;let i = index;"  (click)="GetOfferPaginatedbyCard(C,i)">
                                    {{C.label}}
                                </div>
                            </div>
                        </div>
                    </div>  
                </grid-col>
            </grid-row>
            <grid-row class="justify-content-between mt-30" *ngIf="this.CardName != '' && this.CardName != undefined" >
                <grid-col col="auto">
                    <div class="bg-color-base-3200 pt-4 pb-8 pr-12 pl-12 br-50">
                        <span class="font-400 font-size-12px line-h-16 color-base-800">
                            {{this.CardName}}
                        </span>
                        <ng-icon iconClass="icon-close-10px v-align-middle ml-10" width="10" height="10" (click)="SelctedCard()"></ng-icon>
                    </div>
                </grid-col>
            </grid-row>
            
            <div class="carousel-wrapper mt-10">
                <owl-carousel-o [options]="carouselOptions">
                    <ng-template carouselSlide *ngFor="let item of this.Adsoffer">
                        <div class="img-box mt-30">
                            <img src="data:image/jpg;base64,{{item.bannerPictureBase64}}" alt="">
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>

            <grid-row class="justify-content-center col-space-min mt-20 mt-mobile-20">
                <grid-col col="auto" mobile="12">
                    <div class="custom-tabs-tags-item" [ngClass]="activeTab == -1 ? 'active' : ''" (click)="changeTab(-1,'')">
                        <ng-icon iconClass="icon-all-deal" width="16" height="16"></ng-icon>
                        <span>
                            {{"AllDeals" | translate}}
                        </span>
                    </div>
                    </grid-col>
                <grid-col col="auto" mobile="12" *ngFor="let item of this.OfferCategories;let i = index">
                    <div class="custom-tabs-tags-item" [ngClass]="activeTab == i ? 'active' : ''" (click)="changeTab(i,item)">
                        <img [src]="item.icon" alt="" width="16" height="16">
                        <!-- <ng-icon iconClass="{{item.icon}}" width="16" height="16"></ng-icon> -->
                        <span>
                            <!-- {{item.categoryName}}    -->
                             {{ item.categoryName | translate}}
                        </span>
                    </div>
                </grid-col>
            </grid-row>
            <div class="mt-30">
                <grid-row class="col-space-min">
                    <grid-col col="12">
                        <grid-row class="justify-content-between align-item-center mb-20">
                            <grid-col col="auto">
                                <div class="font-600 font-size-14px line-h-20 color-base-1200">
                                    {{ "DEALSAROUNDYOU" | translate }}
                                </div>
                            </grid-col>
                            <grid-col col="auto">
                                <div class="font-600 font-size-14px line-h-20 color-base-2200 link">
                                    <!-- {{ "ViewAll" | translate }} -->
                                </div>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                    <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6"  *ngFor="let item of this.OfferPaginated">
                        <div class="deal-card" (click)="OfferDetails(item)">
                            <div class="card-img"  >
                                <!-- <img src="~/../assets/images/deal-1-card-img.png" alt=""> -->
                                <img src="data:image/jpg;base64,{{item.thumbnailBase64}}" alt="">
                            </div>
                            <div class="content-box">
                                <div class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                                    {{item.title}}
                                </div>
                                <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                                    {{item.caption}}
                                </div>
                                <grid-row class="mt-30 align-item-center">
                                    <grid-col col="auto">
                                        <wishlist (returnClick)="heartIcon(item.id)" [itemStatus]="item.heart" *ngIf="this.auth?.detailuser"></wishlist>
                                    </grid-col>
                                </grid-row>
                            </div>
                        </div>
                    </grid-col>
                </grid-row>
                <!-- <div class="pagination mt-40">
                    <div class="pagination-item">
                        <ng-icon iconClass="icon-pagination-left mr-50" width="24" height="24"></ng-icon>
                    </div>
                    <div *ngFor="let item of this.totalpages; let i = index;">
                        <div class="pagination-item" [ngClass]="activepagination == i+1 ? 'active' : ''" (click)="paginationTab(item)">
                            {{item}}
                        </div>
                    </div>
                    <div class="pagination-item" [ngClass]="activepagination == this.totalpages.length+1 ? 'active' : ''" (click)="paginationTab(this.totalpages.length+1)">
                        <ng-icon iconClass="icon-pagination-right-active ml-50" width="24" height="24"></ng-icon>
                    </div>
                </div> -->

                <div class="pagination mt-40">
                    <div 
                        class="pagination-item" 
                        [ngClass]="activepagination == 1 ? 'disabled' : ''" 
                        (click)="activepagination > 1 && paginationTab(activepagination - 1)">
                        <ng-icon iconClass="icon-pagination-left mr-50" width="24" height="24"></ng-icon>
                    </div>
                    <div *ngFor="let item of this.totalpages; let i = index;">
                        <div 
                            class="pagination-item" 
                            [ngClass]="activepagination == i + 1 ? 'active' : ''" 
                            (click)="paginationTab(item)">
                            {{ item }}
                        </div>
                    </div>
                    <div 
                        class="pagination-item" 
                        [ngClass]="activepagination == this.totalpages.length ? 'disabled' : ''" 
                        (click)="activepagination < this.totalpages.length && paginationTab(activepagination + 1)">
                        <ng-icon iconClass="icon-pagination-right-active ml-50" width="24" height="24"></ng-icon>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <!-- <div class="post-login-1-col-3">
        <div class="pl-20 pr-20">
            <div class="font-400 font-size-14px line-h-20 color-base-1500 mt-14 letter-spacing-1 mb-10">
                {{"Sponsored" | translate }}
            </div>
            <div class="deal-card pt-10 pb-10">
                <div class="card-img">
                    <img src="~/../assets/images/heath-coverage-img.jpg" alt="">
                </div>
                <div class="content-box bg-2900">
                    <div class="font-600 font-size-14px line-h-20 color-base-1500">
                        {{"NeedMedicalInsurance" | translate }}
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
                        {{"GetYourFamilyMedical" | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>

<!-- Login Required -->
<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Login"
  [whiteButtonStatus]="true" whiteButtonText="Cancel" (doneButton)="loginWithIdNum()" [hideHeader]="false">
  <grid-row class="justify-content-center">
    <grid-col col="8">
      <div class="text-align-center">
        <ng-icon iconClass="icon-info-big" width="56" height="56"></ng-icon>
        <div class="font-size-20px color-base-1300 font-400 line-h-28 mt-30 letter-spacing-1">
          {{"LoginRequired" | translate}}
        </div>
        <div class="font-size-14px color-base-1300 font-400 line-h-22 mt-10 letter-spacing-1">
          {{"PleaseLoginExperience" | translate}}
        </div>
      </div>
    </grid-col>
  </grid-row>
</modal>